// extracted by mini-css-extract-plugin
module.exports = {"container":"PopupBase_container__ASS35","visible":"PopupBase_visible__CCZHw"};